import React, { useState, useEffect, useRef } from "react";

import ReusableTable from "components/Tables/ReusableTable";

import {
  Flex,
  Box,
  Text,
} from "@chakra-ui/react";

import {
  EllipsisVertical,
  EyeIcon,
  Pencil,
  XCircle,
  Image as ImageIcon,
} from "lucide-react";

import ThreeDotMenu from "components/Menus/ThreeDotMenu";

import GradientButton from "components/Buttons/GradientButton";

import StatusBadge, {
  getStatusVariant,
} from "components/Badges/StatusBadge";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { useDispatch, useSelector } from "react-redux";

import {
  fetchDriverTripsAction,
  updateDriverTripAction,
  cancelDriverTripAction,
} from "../../../state/actions/driverTripActions";

import {
  useCustomNotification,
} from "components/Toasts/OpenNotification.js";

import { formatDate } from "utils/dateFormatter";

import ViewDriverTrip from "./components/ViewDriverTrip";
import EditDriverTripDrawer from "./components/EditDriverTripDrawer";
import CancelDriverTrip from "./components/CancelDriverTrip";
import GenerateTripPoster from "./components/GenerateTripPoster";


const DriverTripManagement = () => {

  const dispatch = useDispatch();

  const  showToast  = useCustomNotification();

  const [
    isViewTripOpen,
    setViewTripOpen,
  ] = useState(false);

  const [
    isEditTripOpen,
    setEditTripOpen,
  ] = useState(false);

  const [
    isCancelTripOpen,
    setCancelTripOpen,
  ] = useState(false);

  const [
  selectedPosterTrip,
  setSelectedPosterTrip,
] = useState(null);


const posterRef = useRef(null);
  const [
    selectedTrip,
    setSelectedTrip,
  ] = useState(null);

  const [
    currentPage,
    setCurrentPage,
  ] = useState(1);

  const PAGE_SIZE = 10;



const {
  trips,
  loading,
  error,
  total,
  pages,
} = useSelector((state) => state.driverTrips);
  

  useEffect(() => {

    dispatch(
      fetchDriverTripsAction(
        currentPage,
        PAGE_SIZE
      )
    );

  }, [
    dispatch,
    currentPage,
  ]);


  const handleViewTrip = (trip) => {

    setSelectedTrip(trip);

    setViewTripOpen(true);
  };


  const handleEditTrip = (trip) => {

    setSelectedTrip(trip);

    setEditTripOpen(true);
  };



  const handleCancelTrip = (trip) => {

    setSelectedTrip(trip);

    setCancelTripOpen(true);
  };

const handleGeneratePoster = (trip) => {
      console.log("POSTER TRIP:", trip);
  console.log(
    "INTERMEDIATE STOPS:",
    trip?.intermediate_stops
  );
  showToast({
    type: "info",
    message: "Generating poster...",
    description: "Please wait while your trip poster is being prepared.",
  });

  setSelectedPosterTrip(trip);
};

useEffect(() => {
  if (!selectedPosterTrip) {
    return;
  }

  const generate = async () => {
    try {
      await posterRef.current?.download?.();

      showToast({
        type: "success",
        message: "Poster downloaded",
        description: "Your trip poster has been downloaded successfully.",
      });

      setSelectedPosterTrip(null);
    } catch (error) {
      console.error("Poster generation failed:", error);

      showToast({
        type: "error",
        message: "Poster generation failed",
        description: "Unable to generate the trip poster.",
      });

      setSelectedPosterTrip(null);
    }
  };

  const timer = setTimeout(generate, 300);

  return () => clearTimeout(timer);
}, [selectedPosterTrip, showToast]);

  const handleUpdateTrip = async (tripData) => {

    const response = await dispatch(
      updateDriverTripAction(
        tripData.trip_id,
        tripData
      )
    );

    if (response?.success) {

      showToast({
        type: "success",
        message: "Trip updated successfully.",
      });

      setEditTripOpen(false);
      setSelectedTrip(null);

      dispatch(
        fetchDriverTripsAction(
          currentPage,
          PAGE_SIZE
        )
      );

    } else {

      showToast({
        type: "error",
        message: "Failed to update trip.",
        description:
          response?.error ||
          "Unable to update the trip.",
      });
    }
  };


  const handleConfirmCancel = async () => {

    if (!selectedTrip?.trip_id) {
      return;
    }

    const response = await dispatch(
      cancelDriverTripAction(
        selectedTrip.trip_id
      )
    );

    if (response?.success) {

      showToast({
        type: "success",
        message: "Trip cancelled successfully.",
      });

      setCancelTripOpen(false);
      setSelectedTrip(null);

      dispatch(
        fetchDriverTripsAction(
          currentPage,
          PAGE_SIZE
        )
      );

    } else {

      showToast({
        type: "error",
        message: "Failed to cancel trip.",
        description:
          response?.error ||
          "Unable to cancel the trip.",
      });
    }
  };


  const generateMenuItems = (row) => {

    const trip = row.original;

    return [

      /* VIEW */

      {
        icon: (
          <EyeIcon size={16} />
        ),

        text: "View Trip",

        onClick: () =>
          handleViewTrip(trip),
      },

      {
        icon: (
          <Pencil size={16} />
        ),

        text: "Edit Trip",

        onClick: () =>
          handleEditTrip(trip),
      },
// ...(trip?.status?.toLowerCase() === "active"
//   ? [
      {
        icon: <ImageIcon size={16} />,
        text: "Generate Poster",
        onClick: () => handleGeneratePoster(trip),
      },
//     ]
//   : []),
      {
        icon: (
          <XCircle size={16} />
        ),

        text: "Cancel Trip",

        onClick: () =>
          handleCancelTrip(trip),
      },

    ];
  };



  const columnsData = [
  {
    Header: "Driver",

    accessor: (row) => {
      const firstName =
        row.driver_first_name || "";

      const lastName =
        row.driver_last_name || "";

      const phone =
        row.driver_phone_number || "";

      const fullName =
        `${firstName} ${lastName}`.trim();

      return {
        name: fullName || "N/A",
        phone,
      };
    },

    Cell: ({ value }) => (
      <Box>
        <Text
          fontWeight="600"
          fontSize="sm"
        >
          {value?.name || "N/A"}
        </Text>

        {value?.phone && (
          <Text
            fontSize="xs"
            color="gray.500"
            mt="2px"
          >
            {value.phone}
          </Text>
        )}
      </Box>
    ),
  },
    {
      Header: "Route",

      accessor: (row) =>
        `${row.origin || "N/A"} → ${
          row.destination || "N/A"
        }`,
    },


    {
      Header: "Vehicle",

      accessor: (row) =>
        row.vehicle_type ||
        "N/A",
    },


    {
  Header: "Departure",

  accessor: (row) =>
    row.departure_time,

  Cell: ({ value }) =>
    value
      ? new Date(value).toLocaleString("en-US", {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
      : "N/A",
},


    {
      Header: "Capacity",

      accessor: (row) =>
        `${row.booked_packages || 0} / ${
          row.capacity_packages || 0
        }`,
    },


    {
      Header: "Packages",

      accessor: (row) =>
        row.packages?.length || 0,
    },


    {
      Header: "Status",

      accessor: (row) =>
        row.status || "Unknown",

      Cell: ({ value }) => (

        <StatusBadge
          label={value}
          variant={getStatusVariant(value)}
        />

      ),
    },


    {
      Header: "Created",

      accessor: (row) =>
        row.created_at,

      Cell: ({ value }) =>
        value
          ? formatDate(value)
          : "N/A",
    },

    {
      Header: "Actions",

      accessor: "moreOptions",

      Cell: ({ row }) => (

        <ThreeDotMenu
          icon={
            <EllipsisVertical
              size={20}
              color="grey"
            />
          }

          items={
            generateMenuItems(row)
          }
        />

      ),
    },

  ];


  return (

    <Flex
      flexDirection="column"
      pt={{
        base: "120px",
        md: "25px",
      }}
    >

      {/* HEADER */}

      <Box p={6}>

        <Flex
          justifyContent="space-between"
          alignItems="center"
        >

          <Text
            fontSize="md"
            fontWeight="bold"
          >

            {loading ? (

              <Skeleton
                height="20px"
                width="120px"
              />

            ) : (

              `All Driver Trips: ${total ?? 0}`

            )}

          </Text>

        </Flex>

      </Box>


       <ReusableTable
        columnsData={columnsData}
        tableData={Array.isArray(trips) ? trips : []}
        isLoading={loading}
        error={error}
        />


      <Box
        mt={4}
        display="flex"
        justifyContent="center"
        gap={2}
      >

        <GradientButton

          onClick={() =>
            setCurrentPage(
              (prev) =>
                Math.max(
                  prev - 1,
                  1
                )
            )
          }

          disabled={
            currentPage === 1 ||
            loading
          }

          height="30px"
        >

          Previous

        </GradientButton>


       <Text alignSelf="center">
        Page {currentPage} of {pages || 1}
        </Text>


    <GradientButton
  onClick={() =>
    setCurrentPage((prev) => prev + 1)
  }
  disabled={
    loading ||
    currentPage >= (pages || 1)
  }
  height="30px"
>
  Next
</GradientButton>

      </Box>


      
      {/* VIEW TRIP */}
      

      {selectedTrip && (

        <ViewDriverTrip

          isOpen={
            isViewTripOpen
          }

          onClose={() => {

            setViewTripOpen(false);
            setSelectedTrip(null);

          }}

          trip={
            selectedTrip
          }

        />

      )}


      
      {/* EDIT TRIP */}
      

      {selectedTrip && (

        <EditDriverTripDrawer

          isOpen={
            isEditTripOpen
          }

          onClose={() => {

            setEditTripOpen(false);
            setSelectedTrip(null);

          }}

          trip={
            selectedTrip
          }

          onUpdateTrip={
            handleUpdateTrip
          }

        />

      )}


      
      {/* CANCEL TRIP */}
      

      {selectedTrip && (

        <CancelDriverTrip

          isOpen={
            isCancelTripOpen
          }

          onClose={() => {

            setCancelTripOpen(false);
            setSelectedTrip(null);

          }}

          onConfirm={
            handleConfirmCancel
          }

          trip={
            selectedTrip
          }

        />

      )}

      {/* {selectedPosterTrip?.status?.toLowerCase() === "active" &&  ( */}
    <GenerateTripPoster
        ref={posterRef}
        trip={selectedPosterTrip}
        driverPhone={
        selectedPosterTrip?.driver_phone_number
        }
    />
    {/* )} */}

    </Flex>

  );
};


export default DriverTripManagement;